import BlockSubcategoryImage from './BlockSubcategoryImage';
export default BlockSubcategoryImage;
